import axios from 'axios';

function resolveBase() {
  if (process.env.NODE_ENV === 'production') return '/api/testflight';
  if (process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/testflight`;
  }
  return `http://${window.location.hostname}:3151/api/testflight`;
}

const api = axios.create({ baseURL: resolveBase() });

let tokenGetter = null;

export function setTestFlightTokenGetter(fn) {
  tokenGetter = fn;
}

api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getApps = () => api.get('/apps');
export const getBuilds = (appId) => api.get(`/apps/${appId}/builds`);
export const getUsers = () => api.get('/users');
export const getBetaGroups = (appId) => api.get(`/apps/${appId}/beta-groups`);
export const getTesters = (groupId) => api.get(`/beta-groups/${groupId}/testers`);
export const inviteTester = (groupId, data) => api.post(`/beta-groups/${groupId}/testers`, data);
export const removeTester = (groupId, testerId) =>
  api.delete(`/beta-groups/${groupId}/testers/${testerId}`);
